/**
 * Таблица пресетов гидравлического разделителя для режима «Для клиентов».
 * Используется в CharacteristicsCalculator и CollectorWithSeparatorCharacteristicsCalculator.
 * Ключ — номинал стандартного изделия (кВт), совпадает с HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS.
 * flowRate — м³/ч при referenceDeltaTemp: P_номинал·c·ΔT (вода, c=4190), округление до 0,01.
 */

export const HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS = [
  40, 50, 60, 85, 135, 170, 200, 250, 400, 600, 800, 1000,
];
export const HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS_MAX =
  HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS[HYDRAULIC_SEPARATOR_CLIENT_POWER_STEPS.length - 1];

export const HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE = {
  40: {
    diameter: 60.3,
    wallThickness: 2,
    squareProfile: '60x60',
    squareWallThickness: 2,
    capType: 'straight',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 26.9,
    flowRate: 1.37,
    referenceDeltaTemp: 25,
    left: { firstOffset: 52, lastOffset: 77, spacing: 125 },
    right: { firstOffset: 77, lastOffset: 52, spacing: 125 },
  },
  50: {
    diameter: 76.1,
    wallThickness: 2,
    squareProfile: '80x80',
    squareWallThickness: 2,
    capType: 'straight',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 26.9,
    flowRate: 1.72,
    referenceDeltaTemp: 25,
    left: { firstOffset: 52, lastOffset: 77, spacing: 125 },
    right: { firstOffset: 77, lastOffset: 52, spacing: 125 },
  },
  60: {
    diameter: 88.9,
    wallThickness: 2,
    squareProfile: '80x80',
    squareWallThickness: 2,
    capType: 'straight',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 33.7,
    flowRate: 2.06,
    referenceDeltaTemp: 25,
    left: { firstOffset: 50, lastOffset: 75, spacing: 125 },
    right: { firstOffset: 75, lastOffset: 50, spacing: 125 },
  },
  85: {
    diameter: 88.9,
    wallThickness: 2,
    squareProfile: '80x80',
    squareWallThickness: 2,
    capType: 'straight',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 42.4,
    flowRate: 2.92,
    referenceDeltaTemp: 25,
    left: { firstOffset: 70, lastOffset: 104, spacing: 150 },
    right: { firstOffset: 104, lastOffset: 70, spacing: 150 },
  },
  135: {
    diameter: 101.6,
    wallThickness: 2,
    squareProfile: '100x100',
    squareWallThickness: 3,
    capType: 'straight',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 48.3,
    flowRate: 4.64,
    referenceDeltaTemp: 25,
    left: { firstOffset: 82, lastOffset: 117, spacing: 200 },
    right: { firstOffset: 117, lastOffset: 82, spacing: 200 },
  },
  170: {
    diameter: 114.3,
    wallThickness: 2,
    squareProfile: '100x100',
    squareWallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 48.3,
    flowRate: 5.84,
    referenceDeltaTemp: 25,
    left: { firstOffset: 100, lastOffset: 100, spacing: 200 },
    right: { firstOffset: 100, lastOffset: 100, spacing: 200 },
  },
  200: {
    diameter: 129,
    wallThickness: 2,
    squareProfile: '150x150',
    squareWallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'nipple',
    connectionSize: 48.3,
    flowRate: 6.87,
    referenceDeltaTemp: 25,
    left: { firstOffset: 125, lastOffset: 125, spacing: 200 },
    right: { firstOffset: 125, lastOffset: 125, spacing: 200 },
  },
  250: {
    diameter: 159,
    wallThickness: 2,
    squareProfile: '150x150',
    squareWallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    flowRate: 10.74,
    referenceDeltaTemp: 20,
    nipple: {
      connectionType: 'nipple',
      connectionSize: 60.3,
      left: { firstOffset: 125, lastOffset: 125, spacing: 200 },
      right: { firstOffset: 125, lastOffset: 125, spacing: 200 },
    },
    flange: {
      connectionType: 'flange',
      connectionSize: 50,
      left: { firstOffset: 100, lastOffset: 100, spacing: 300 },
      right: { firstOffset: 100, lastOffset: 100, spacing: 300 },
    },
  },
  400: {
    diameter: 159,
    wallThickness: 2,
    squareProfile: '150x150',
    squareWallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'flange',
    connectionSize: 65,
    flowRate: 17.18,
    referenceDeltaTemp: 20,
    left: { firstOffset: 150, lastOffset: 150, spacing: 300 },
    right: { firstOffset: 150, lastOffset: 150, spacing: 300 },
  },
  600: {
    diameter: 159,
    wallThickness: 2,
    squareProfile: '150x150',
    squareWallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'flange',
    connectionSize: 80,
    flowRate: 25.78,
    referenceDeltaTemp: 20,
    left: { firstOffset: 150, lastOffset: 150, spacing: 300 },
    right: { firstOffset: 150, lastOffset: 150, spacing: 300 },
  },
  800: {
    diameter: 219.1,
    wallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1.2',
    bottomCapFitting: 'Mufta_1.2',
    connectionType: 'flange',
    connectionSize: 100,
    flowRate: 34.37,
    referenceDeltaTemp: 20,
    left: { firstOffset: 240, lastOffset: 240, spacing: 480 },
    right: { firstOffset: 240, lastOffset: 240, spacing: 480 },
  },
  1000: {
    diameter: 273,
    wallThickness: 3,
    capType: 'elliptical',
    topCapFitting: 'Mufta_1',
    bottomCapFitting: 'Mufta_1',
    connectionType: 'flange',
    connectionSize: 100,
    flowRate: 42.96,
    referenceDeltaTemp: 20,
    left: { firstOffset: 270, lastOffset: 270, spacing: 535 },
    right: { firstOffset: 270, lastOffset: 270, spacing: 535 },
  },
};
